import {User} from './user';

export class Authorization {
  access_token: string;
  token_type: string;
  refresh_token: string;
  expires_in: number;
  scope: string;
  user: User;

  constructor() {

  this.access_token = '';
  this.token_type = '';
  this.refresh_token = '';
  this.expires_in = 0;
  this.scope = '';
  this.user = new User;
  }
}



// WEBPACK FOOTER //
// ./src/models/authorization.ts